<script setup>
import {useRoute} from "vue-router"
const route = useRoute()
const router = useRouter()

const thePublicId = route.params.all[0]
router.push('/' + thePublicId + '/activate')
</script>



<route lang="yaml">
meta:
  layout: none
  action: read
  subject: Auth
  redirectIfLoggedIn: false
</route>
